<template>
  <form class="col-md-6 col-lg-6">
    <div class="form-group">
      <label class="form__label" for="filter">
        <font-awesome-icon :icon="['fas', 'filter']" class="mr-lg-2 mr-md-2 mr-2 icon"/>
        FILTER</label>
      <input v-model="keywordsInput" id="filter"
             type="text" class="form-control form__input"
             placeholder="Enter keywords...">
    </div>
  </form>
</template>

<script>
  import {getProviderByNpi }   from "@/api/getters/provider";
  import {mapGetters} from 'vuex';
  import {
    getDescByCcd,
    getCodeByCcd,
    getAllMeasByProcId,
    getAllProcedureKinds
  } from '@/data/getters';

  export default {
    name: "FilterPage",
    props: {
      arrayToFilter: Array,
      type: String,
    },
    data() {
      return {
        keywordsInput: '',
        keywords: [],
        debouncedFilter: null
      }
    },
    computed: {
      ...mapGetters('login', {
        allData: 'getAllData',
      })
    },
    watch: {
      keywordsInput: function () {
        let keywords = this.keywordsInput.trim().split(' ');
        if(keywords.length == 1 && keywords[0] == '')
          this.keywords = [];
        else
          this.keywords = keywords.map(keyword => keyword.toLowerCase());
        (this.getFilter())();
      },
    },
    methods: {
      /**
       * @param index of code to test
       * @returns boolean true of if it matches
       */
      getProviderByNpi,
      doesMatch(codeId) {
        let description = this.getDescByCcd(codeId,this.allData).toLowerCase();
        return this.keywords.some(keyword => description.includes(keyword) || this.getCodeByCcd(codeId,this.allData).toLowerCase().includes(keyword));
      },
      doesMatchNpi(npiId) {
        let provider = this.getProviderByNpi(this.allData,npiId);
        let name = [provider.firstName,provider.middleName,provider.lastName].join().toLowerCase();
        
        return this.keywords.some(keyword => name.includes(keyword) ||
          provider.specialties.some(specialty => specialty.name.toLowerCase().includes(keyword)));
      },
      doesMatchReport(report) {
        let test = 
          field => 
            keyword => 
              field && field.toLowerCase().includes(keyword);
        return this.keywords.every(
          keyword =>
            test(report.category)(keyword) ||
            test(report.procCcd)(keyword));
      },
      filterReports()
      {
        let keywords = this.keywords;
        let filtered = this.arrayToFilter.filter(item => keywords.length === 0 ||  this.doesMatchReport(item));          
        this.$emit('update-keywords', this.keywords);
        this.$emit('filterArray', filtered);
      },      
      filterProviders()
      {
        let doesMatchNpi = this.doesMatchNpi;
        let keywords = this.keywords;
        let filtered = this.arrayToFilter.filter(item => keywords.length === 0 || item.npis.some(doesMatchNpi));
        this.$emit('update-keywords', this.keywords);
        this.$emit('filterArray', filtered);
      },
      doesKindMatch(procedureKind){
        return this.keywords.some(keyword => procedureKind.procName.toLowerCase().includes(keyword))
      },
      filterNonProcedures() {
        let doesMatch = this.doesMatch;
        let keywords = this.keywords;
        let filtered = this.arrayToFilter.filter(item => keywords.length === 0 || item.codes.some(doesMatch));
        this.$emit('update-keywords', this.keywords);
        this.$emit('filterArray', filtered);
      },
      filterProcedures() {
        let getMeasures = procId => this.getAllMeasByProcId(procId,this.allData).map(meas => meas.ccd);
        let doesMatch = this.doesMatch;
        let keywords = this.keywords;
        let filtered = this.arrayToFilter.filter(procedure => 
          keywords.length === 0 ||
          procedure.codes.some(doesMatch) ||
          procedure.ids.some(procId => getMeasures(procId).some(doesMatch))
        );
        this.$emit('update-keywords', this.keywords);
        this.$emit('filterArray', filtered);
      },
      filterProcedureKinds() {
        let keywords = this.keywords
        let filtered = this.arrayToFilter.filter(procedureKind =>
          keywords.length === 0 ||
          this.doesKindMatch(procedureKind))
        this.$emit('update-keywords', this.keywords)
        this.$emit('filterArray', filtered)
      },
      filterLabKinds() {
        // Historical Labs page: filter by panel or analyte name.
        const keywords = this.keywords;
        const filtered = this.arrayToFilter.filter((labKind) =>
          keywords.length === 0
          || keywords.some((kw) => labKind.labName && labKind.labName.toLowerCase().includes(kw.toLowerCase()))
        );
        this.$emit('update-keywords', this.keywords);
        this.$emit('filterArray', filtered);
      },
      getCcdDescriptionById(id) {
        return getDescByCcd(id, this.allData);
      },
      getCcdCodeById(id) {
        return getCodeByCcd(id,this.allData);
      },
      getFilter() {
        let debouncedFilter = null;
        switch (this.type) {
          case 'DIAGNOSIS':
          case 'MEDICATION':
          case 'VACCINATION':
          case 'ALLERGY':
            debouncedFilter = _.debounce(this.filterNonProcedures, 800);
            break;
          case 'PKINDS':
            debouncedFilter = _.debounce(this.filterProcedureKinds, 800)
            break;
          case 'LABKINDS':
            debouncedFilter = _.debounce(this.filterLabKinds, 800);
            break;
          case 'PROCEDURE':
            debouncedFilter = _.debounce(this.filterProcedures, 800);
            break;
          case 'PROVIDERS':
            debouncedFilter = _.debounce(this.filterProviders, 800);
            break;
          case 'REPORTS':
            debounceFilter = _.deboune(this.filterProviders, 800);
            break;
        }
        return debouncedFilter;
      },
      getDescByCcd,
      getCodeByCcd,
      getAllMeasByProcId,
      getAllProcedureKinds
    }
  }

</script>

<style scoped lang="scss">
  .form__label {
    font-size: 0.85rem;
    color: lighten(#000, 30%);
  }

  .form__input {
    font-size: 0.75rem;
    color: lighten(#000, 30%);
  }

  .icon {
    color: lighten(#000, 50%);
  }
</style>
